export default {
  apiError: state => state.apiError,
  stripePublishableKey: state => state.stripePublishableKey,
  facebookAppId: state => state.facebookAppId,
  googleApiKey: state => state.googleApiKey,
  pusherApiKey: state => state.pusherApiKey,
  googleMapsSecret: state => state.googleMapsSecret,
  onesignalAppId: state => state.onesignalAppId,
  sendbeeDevelopersDocs: state => state.sendbeeDevelopersDocs,
  pusherChannels: state => state.pusherChannels,
  pusherAuthEndpoint: state => state.pusherAuthEndpoint,
  webApiRoot: state => state.webApiRoot,
  waSettings: state => state.waSettings,
  contactFilterLimits: state => state.contactFilterLimits,
  contactImportLimits: state => state.contactImportLimits,
  maxBroadcastNumbers: state => state.maxBroadcastNumbers,
  showAnnouncement: state => state.showAnnouncement,
};
